export default class ResetPasswordFormProps {
    constructor(public recoveryCode: string = '', public user: string = '', public password: string = '', public confirmedPassword: string = '') {}
}
